import { IconArrowLeft } from './IconArrowLeft'

export default IconArrowLeft
